// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/icon/icon.component.scss
// module id = 213
// module chunks = 0